<template>
  <el-dialog title="选择导出范围" :visible.sync="visible" width="330px" append-to-body>
    <el-radio-group v-model="scope" style="display:flex;flex-direction:column;gap:12px;">
      <el-radio label="header">仅头表</el-radio>
      <el-radio label="full">头表 + 明细</el-radio>
    </el-radio-group>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="doExport">确定导出</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExportScopeDialog',
  data() {
    return {
      visible: false,
      scope: 'header',
      loading: false,
      moduleName: '',
      exportFn: null,
      exportFileName: '导出数据'
    }
  },
  methods: {
    open(moduleName, exportFn, exportFileName) {
      this.moduleName = moduleName
      this.exportFn = exportFn
      this.exportFileName = exportFileName || '导出数据'
      this.scope = 'header'
      this.visible = true
    },
    async doExport() {
      if (!this.exportFn) return
      this.loading = true
      try {
        await this.exportFn({ scope: this.scope })
        this.visible = false
      } catch (e) {
        // exportFn 内部已有错误提示
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
